<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        :row-multi-select-with-click="true"
        @refresh="onRefresh"
        @selectionChanged="selectionChanged"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteRoomProperty"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify"
        class="btn primary small"
        @click="updateRoomPropertyView"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>
    <!-- <el-col class="bottom-btns-container">
      <el-button
        type="primary"
        @click="dialogFormVisible = true"
      >Thêm thuộc tính</el-button>
      <el-button type="danger" @click="deleteRoomProperty">
        Xóa thuộc tính
      </el-button>
    </el-col> -->
    <el-dialog
      :title="!isEdit ? 'Thêm thuộc tính phòng' : 'Sửa thuộc tính phòng'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã thuộc tính</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã thuộc tính"
                  >
                    <input v-model="item.code" type="text" :disabled="isEdit" />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mô tả</div>
                  <validation-provider
                    rules="required|max:255"
                    name="Mô tả thuộc tính"
                  >
                    <textarea
                      v-model="item.description"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <!-- <validation-observer ref="formValidator">
        <el-form :model="item">
          <validation-provider rules="required" name="Mã thuộc tính">
            <el-form-item class="required" label="Mã thuộc tính phòng">
              <el-input v-model="item.code" placeholder="Nhập thông tin" />
            </el-form-item>
          </validation-provider>
          <validation-provider rules="required" name="Mô tả thuộc tính">
            <el-form-item label="Mô tả">
              <el-input
                v-model="item.description"
                type="textarea"
                placeholder="Nhập thông tin"
              />
            </el-form-item>
          </validation-provider>
        </el-form>
      </validation-observer> -->

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateRoomProperty"
          >
            {{ $t('button.update') }}
          </button>
          <button
            v-else
            class="btn primary small outline"
            @click="addRoomProperty"
          >
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import bus from '@/utils/bus'

import {
  getListRoomPropertyApi,
  addRoomPropertyApi,
  updateRoomPropertyApi,
  deleteRoomPropertyApi
} from '@/api/Room/roomProperty'
import { Message } from 'element-ui'
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      isDisableModify: false,
      isDisableDelete: false,
      loading: false,
      titlePopup: 'Thêm thuộc tính phòng',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC'
      },
      item: {
        code: '',
        description: '',
        id: null
      },

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false,
          sortable: false
        },
        {
          headerName: 'Mã thuộc tính phòng',
          field: 'code',
          width: 100,
          sortable: false
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          sortable: false
        }
      ],
      rows: []
    }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    selectionChanged(rows) {
      if (rows.length == 0) {
        this.isDisableModify = true
        this.isDisableDelete = true
      } else if (rows.length > 1) {
        this.isDisableModify = true
        this.isDisableDelete = false
      } else {
        this.isDisableModify = false
        this.isDisableDelete = false
      }
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    onDoubleClicked(rows) {
      // this.titlePopup = "Sửa thuộc tính phòng";
      // this.isEdit = true;
      const rowData = rows[0]
      // this.item.code = rowData.code;
      // this.item.description = rowData.description;
      // this.item.id = rowData.id;
      // this.dialogFormVisible = true;
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    updateRoomPropertyView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.isEdit = true
        this.titlePopup = 'Sửa thuộc tính phòng'
        const rowData = rowsSelected[0]
        this.item.code = rowData.code
        this.item.description = rowData.description
        this.item.id = rowData.id
        this.dialogFormVisible = true
      }
    },
    async attachData() {
      this.loading = true
      let data = await getListRoomPropertyApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    },
    async addRoomProperty() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await addRoomPropertyApi(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async updateRoomProperty() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateRoomPropertyApi(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteRoomProperty() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteRoomPropertyConfirm'), () => {
          deleteRoomPropertyApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },

    resetItemInfo() {
      this.item.code = ''
      this.item.description = ''
      this.item.id = null
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetItemInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
